<div class="container" [formGroup]="bulkForm">
    <div class="row wrapperRow">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <h4>Import Teilnahmen
            </h4>
        </div>
    </div>

    <div class="row wrapperRow">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-content>
                    <label>Import von</label>
                    <mat-radio-group aria-label="Import von" class="radio-group" formControlName="type"
                        (change)="changeValidation($event)">
                        <mat-radio-button value="INPUT_TYPE_VOUCHER">Gutscheinen</mat-radio-button>
                        <mat-radio-button value="INPUT_TYPE_CARD">Karten</mat-radio-button>
                        <mat-error *ngIf="bulkForm.controls['type'].hasError('required')">
                            Importtyp <strong>muss</strong> angegeben werden
                        </mat-error>

                    </mat-radio-group>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row wrapperRow marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-content>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Teilnahme am:</mat-label>
                                <input matInput formControlName="date" type="date">
                                <mat-error *ngIf="bulkForm.controls['date'].hasError('required')">
                                    Teilnahme am <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="this.bulkForm.getRawValue().type == 'INPUT_TYPE_CARD'">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Aktion</mat-label>
                                <mat-select formControlName="eventPublicID">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="bulkForm.controls['eventPublicID'].hasError('required')">
                                    Aktion <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field class="full-width">
                                <mat-label>Nutzungsdaten:</mat-label>
                                <textarea matInput formControlName="data" rows="10" cols="80"></textarea>
                                <mat-error *ngIf="bulkForm.controls['data'].hasError('required')">
                                    Nutzungsdaten <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="importData()"> Importieren</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
    <div class="row wrapperRow marginTop2Rem" *ngIf="hasImportedData">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <h4>Gescheiterte Zuordnung
            </h4>
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef>
                        #
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                        {{i+1}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="customer">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="processType">
                        Kunde
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.customer }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="event">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
                        Aktion
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.event}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="input">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="size">
                        Eingabe
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.input}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
            </table>
        </div>
    </div>

    <div class="row wrapperRow marginTop2Rem" *ngIf="hasImportedData">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <h4>Erfolgreiche Zuordnung
            </h4>
            <table mat-table [dataSource]="dataSource_success" matSort class="mat-elevation-z2">
                <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef>
                        #
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                        {{i+1}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="customer">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="processType">
                        Kunde
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.attendingAccount.displayName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="event">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
                        Aktion
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.event.title}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="input">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="size">
                        Eingabe
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-column">
                        {{element.id}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
            </table>
        </div>
    </div>
</div>